module.exports = __webpack_public_path__ + "static/media/16.b4aa6a29.svg";